
import { Options, Vue } from "vue-class-component";
import { initialName, dateToTime } from "@/app/infrastructures/misc/Utils";
import { NotificationController } from "@/app/ui/controllers/NotificationController";
import ModalShowImage from "@/app/ui/components/modal-show-image/index.vue";
import "@/app/ui/assets/css/quill.core.css";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

@Options({
  components: {
    ModalShowImage
  }
})
class Detail extends Vue {
  isShow = false;

  get id() {
    return this.$route.params.id;
  }

  get isLoading() {
    return NotificationController.isLoading;
  }

  created() {
    this.getDetail(this.id);
  }

  getDetail(id: any) {
    NotificationController._getDetail(id);
  }

  get detailData() {
    return NotificationController.detailNotification;
  }

  get isError() {
    return NotificationController.isError;
  }

  get errorCause() {
    return NotificationController.errorCause;
  }

  onOpenShowImage() {
    this.isShow = true;
  }

  onCloseShowImage() {
    this.isShow = false;
  }

  get initialNameNotification() {
    const initialValue = initialName(`${this.detailData.createdBy}`);
    if (!initialValue) {
      return {
        initial: "",
        color: ""
      };
    }
    return initialValue;
  }

  formatDate(date: string) {
    return formatDate(date);
  }

  fileName(name: string) {
    const shortName = `${name.substr(0, 28)}...`;
    return name.length > 10 ? shortName : name;
  }

  goBack() {
    this.$router.push(`/notifications`);
  }
}
export default Detail;
